<template>
  <div :class="scrollY > scroll ? 'time-line-view' : ''" :style="scrollY < (scroll-172) ? 'opacity: 0' : '0'">
    <div class="body-1 date flex align-center">
      {{ date }}
    </div>
    <div class="body-2">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TimeLineItem',
  props: {
    date: {
      type: String
    },
    scroll: {
      type: String
    }
  },
  data () {
    return {
      scrollY: window.scrollY
    }
  },
  mounted () {
    window.addEventListener('scroll', () => {
      this.scrollY = window.scrollY
    })
  }
}
</script>

<style lang="scss">
.time-line, .time-line-b, .time-line-l {
  div {
    transition: all .7s ease;
  }
  .body-1 {
    gap: 8px;
    color: #505050;
  }
  .body-1:before {
    content: '';
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background: #EEEEEE;
    border: 1px solid #005245;
    transition: all .6s ease;
  }
  .body-2 {
    color: #505050;
    margin-left: 20px;
    max-width: 500px;
    line-height: 20px;
    margin-top: -4px;
  }
}
@media screen and (max-width: 492px){
  .body-2{
    font-size: 14px;
    line-height: 15px !important;
  }
}
@media screen and (max-width: 464px){
  .time-line-b {
    left: -8px;
  }
  .time-line-b .body-1{
    align-items: center !important;
  }
  .time-line-b .body-2 {
    text-align: center;
  }
}
.time-line-b {
  .body-1 {
    flex-direction: column;
    align-items: start;
    gap: 4px;
  }
  .body-2 {
    margin-top: 0px;
    color: #505050;
    max-width: 260px;
    line-height: 20px;
    margin-left: 0;
  }
}

.time-line-l {
  .body-1 {
    align-items: center;
    flex-direction: row-reverse;
    gap: 8px;
    color: #505050;
  }
  .body-1:before {
    content: '';
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background: #EEEEEE;
    border: 1px solid #005245;
  }
  .body-2 {
    margin-top: 0px;
    margin-right: 20px;
    color: #505050;
    max-width: 270px;
    line-height: 20px;
  }
}
.time-line-view .body-1:before {
  background: #005245;
}
</style>